import createNewActionLight from "../../../../contents/images/products/product-analytics/toolbar-create-new-action-light-mode.mp4";
import createNewActionDark from "../../../../contents/images/products/product-analytics/toolbar-create-new-action-dark-mode.mp4";
import typeItLight from "../../../../contents/images/tutorials/toolbar/type-it-light-mode.mp4";
import typeItDark from "../../../../contents/images/tutorials/toolbar/type-it-dark-mode.mp4";
import toolbarSelectEditLight from "../../../../contents/images/tutorials/toolbar/toolbar-selector-edit-light-mode.mp4";
import toolbarSelectEditDark from "../../../../contents/images/tutorials/toolbar/toolbar-selector-edit-dark-mode.mp4";
import toolbarViewActionsLight from "../../../../contents/images/products/product-analytics/toolbar-view-actions-light-mode.png";
import toolbarViewActionsDark from "../../../../contents/images/products/product-analytics/toolbar-view-actions-dark-mode.png";
import * as React from 'react';
export default {
  createNewActionLight,
  createNewActionDark,
  typeItLight,
  typeItDark,
  toolbarSelectEditLight,
  toolbarSelectEditDark,
  toolbarViewActionsLight,
  toolbarViewActionsDark,
  React
};